namespace advisorop.components.servicer {
    
    export class FirmManagerController {

        advisoryFirmId: number;
        activeTab: number = 1;
        reloadProductsControl: number = 0;
        reloadProductTypeControl: number = 0;

        dgTamps: DevExpress.ui.dxDataGridOptions;
        dgManagers: DevExpress.ui.dxDataGridOptions;
        nbMinInvAmount: DevExpress.ui.dxTextBoxOptions;
        manager: domains.IAdvisoryFirmManager = {};
        managers: domains.IAdvisoryFirmManager[] = [];
        selGlobalManager: domains.IManager;
        globalManagers: domains.IManager[] = [];

        // #region should go into new control Products
        tampProductList: Array<domains.ITampProduct> = [];
        firmProduct: domains.IAdvisoryFirmProduct = {};
        firmProducts: domains.IAdvisoryFirmProduct[];
        firmProductTypes: domains.IAdvisoryFirmProductType[] = [];
        selProductType: domains.IAdvisoryFirmProductType;
        managerProducts: domains.IManagerProduct[] = [];
        selManagerProduct: domains.IManagerProduct;
        selManager: domains.IAdvisoryFirmManager;
        selDataSource: domains.ILOV;
        selSubDataSource: domains.ILOV;
        dataSources: domains.ILOV[] = [];
        subDataSources: domains.ILOV[] = [];
        compensationType: any = domains.CompensationType;
        // #endregion


        static $inject = ["servicerService", "generalService", "$scope", "advisoryFirmApi"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private $scope: ng.IScope,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dgManagers = {
                export: {
                    enabled: true,
                    fileName: "Managers"
                },
                bindingOptions: {
                    dataSource: "vm.managers"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no Managers assigned to this Firm",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "managerName", caption: "Manager", cellTemplate: "colFullName" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "170" }
                ]
            };

            this.dgTamps = {
                export: {
                    enabled: true,
                    fileName: "AdvisoryFirmTamps"
                },
                bindingOptions: {
                    dataSource: "vm.advisoryFirmTamps"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no tamps assigned to this Firm",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "managerName", caption: "Manager", cellTemplate: "colFullName" },
                    { dataField: "assignedStatusDescription", caption: "Status" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "80" }
                ]
            };

            this.nbMinInvAmount = {
                
                mask:"#,##0.00"
            }
        }

        refreshProducts() {
            this.reloadProductsControl++;
            // this.loadFirmProductTypes();
        };
        refreshProductTypes() {
            this.reloadProductTypeControl++;
        };

        loadFirmManagers(): void {
            this.servicerService.getFirmManagers(this.advisoryFirmId)
                .then(response => this.managers = response.data,
                      err => toastr.error("Error occured during managers list loading. " + err.data));
        };

        // #region should go into new control Products
        
        managerChanged(): void {
            if (this.selManager) {
                this.selProductType = null;
                this.selManagerProduct = null;
                this.loadFirmProductTypes(this.selManager.managerId);
                this.loadFirmProducts(this.selManager.managerId);
            }
        }

        loadAssignedTampsForAdvisoryFirm(firmProductId: number, advisoryFirmProductId: number) {
            this.servicerService.getAssignedAdvisoryFirmTamps(firmProductId, advisoryFirmProductId)
                .then(response => {
                    this.advisoryFirmTamps = response.data;
                })
                , err => toastr.error("Error while fetching assigned tamp for product!");
        };

        loadTampsProduct(firmProductId: number, advisoryFirmId: number): void {
            this.servicerService.getTampsProduct(firmProductId, advisoryFirmId)
                .then(response => {
                    this.tampProductList = response.data;
                }), err => toastr.error("Unable to fetch assigned tamp products.");
        }

        editProduct(product: domains.IAdvisoryFirmProduct): void {
            this.servicerService.getFirmProduct(product.id)
                .then(response => {
                    this.firmProduct = response.data;

                    if (this.firmProduct.productAccess == 2) {
                        this.loadAssignedTampsForAdvisoryFirm(product.id, this.advisoryFirmId);
                        this.loadTampsProduct(product.id, this.advisoryFirmId);
                    }

                    this.advisoryFirmId = this.firmProduct.advisoryFirmId;

                    this.selProductType = this.firmProductTypes.filter(v => v.productTypeId == this.firmProduct.productTypeId)[0];
                    this.loadManagerProducts(this.selProductType.managerProductTypeId, this.advisoryFirmId);
                     
                    this.selDataSource = { value: this.firmProduct.dataSource };
                    this.selSubDataSource = { value: this.firmProduct.subDataSource };
                    this.dataSourceChanged();
                }),
                err => toastr.error("Can not load firm product");
        };

        productTypeChanged(): void {
            this.selManagerProduct = null;
            if (this.selProductType && this.advisoryFirmId) {
                this.loadManagerProducts(this.selProductType.managerProductTypeId, this.advisoryFirmId);
            }
        };

        loadFirmProductTypes(managerId: number): void {
            //console.log("Loading Firm product types...Manager id=", managerId);
            this.servicerService.getAdvisoryFirmProductTypes(this.advisoryFirmId, managerId)
                .then(response => {
                    this.firmProductTypes = response.data;
                    //console.log(this.firmProductTypes);
                },
                err => toastr.error("Cannot fetch Product Types. " + err.data));
        };
        loadManagerProducts(managerProductTypeId: number, advisoryFirmId: number): void {
            this.servicerService.getManagerProductsByManagerProductType(managerProductTypeId, advisoryFirmId)
                .then(response => {
                    this.managerProducts = response.data;

                    if (this.firmProduct.id > 0) {
                        this.selManagerProduct = this.managerProducts.filter(v => v.id == this.firmProduct.managerProductId)[0];
                    }
                },
                err => toastr.error("Cannot fetch Products of select type. " + err.data));
        };
        loadFirmProducts(managerId: number): void {
            this.servicerService.getFirmProducts(this.advisoryFirmId)
                .then(response => {
                    this.firmProducts = response.data.filter(v => v.managerId == managerId);
                }, err => toastr.error("Product list can not be loaded. " + err.data));
        };

        advisoryFirmTamps: Array<domains.IAdvisoryFirmTamp> = [];
        loadFirmTamps(advisoryFirmId: number): void {
            this.servicerService.getFirmTamps(advisoryFirmId)
                .then(response => {
                    this.advisoryFirmTamps = response.data;
                    this.dgTamps.dataSource = this.advisoryFirmTamps;
                }),
                err => toastr.error("Cannot load tamps for this advisory firm.");
        };


        assignTampToProduct(tamp: domains.IAdvisoryFirmTamp): void {

            if (!this.selManager || !this.selProductType || !this.selManagerProduct) {
                toastr.warning("Please fill in all fields on form.");
                return;
            }

            let tempTamp: domains.ITampProduct = {
                advisoryFirmId: this.advisoryFirmId,
                id: 0,
                managerName: this.selManager.managerName,
                productName: this.selManagerProduct.name,
                productTypeName: this.selProductType.productTypeName,
                tampId: tamp.tampId,
                advisoryFirmProductId: 0
            }

            if (this.chechForDuplicateTamps(tempTamp)) {
                toastr.warning("This tamp is already assigned.");
                return;
            }

            this.tampProductList.push(tempTamp);
            this.advisoryFirmTamps.filter(x => x.tampId === tamp.tampId)[0].assignedStatus = true;
            this.advisoryFirmTamps.filter(x => x.tampId === tamp.tampId)[0].assignedStatusDescription = "Assigned";
        }

        chechForDuplicateTamps(tampProduct: domains.ITampProduct): boolean {
            let exist: boolean = false;
            for (let i = 0; i < this.tampProductList.length; i++) {
                if (this.tampProductList[i].tampId == tampProduct.tampId)
                    exist = true;
            }
            return exist;
        };

        unassigneTampFromProduct(tamp: domains.IAdvisoryFirmTamp): void {
            let tampProduct = this.tampProductList.filter(x => x.tampId === tamp.tampId)[0];
            var ind = this.tampProductList.indexOf(tampProduct);

            if (ind >= 0) {
                this.tampProductList.splice(ind, 1);
                this.advisoryFirmTamps.filter(x => x.tampId === tamp.tampId)[0].assignedStatus = false;
                this.advisoryFirmTamps.filter(x => x.tampId === tamp.tampId)[0].assignedStatusDescription = "Unassigned";
            }
        }

        validateProductForm(): boolean {
            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["frmpdrct"]);

            if (!formIsValid)
                toastr.error("Account application is not complete. Please correct errors and try again");

            return formIsValid;
        };

        cancel(): void {
            this.firmProduct = {};
            this.selDataSource = {};
            this.selSubDataSource = {};
            this.selProductType = {};
            this.selManagerProduct = {};
        };

        updateFirmProduct() {

            if (this.selDataSource) {
                this.firmProduct.dataSource = this.selDataSource.value;
                if (this.selDataSource.value == domains.DataSource.PORTFOLIO_ACCOUNTING_SYSTEM && this.selSubDataSource) {
                    this.firmProduct.subDataSource = this.selSubDataSource.value;
                }
            } else {
                this.firmProduct.dataSource = null;
                this.firmProduct.subDataSource = null;
            }

            this.firmProduct.tamps = this.tampProductList;

            this.servicerService.updateFirmProduct(this.firmProduct).
                then(response => {
                    this.firmProduct = response.data;
                    toastr.success("Product successfully updated.");
                    this.cancel();
                    this.loadFirmProducts(this.selManager.managerId);
                }),
                err => toastr.error("Product is not updated");
        };

        registerNewProduct() {
            //if (!this.validateProductForm())
            //    return;

            if (!this.selManager || !this.selProductType || !this.selManagerProduct || !this.selDataSource) {
                toastr.warning("Please fill in all fields");
                return;
            }

            this.firmProduct.id = 0;
            this.firmProduct.advisoryFirmId = this.advisoryFirmId;
            this.firmProduct.managerProductId = this.selManagerProduct.id;
            this.firmProduct.managerId = this.selManager.managerId;
            this.firmProduct.productTypeId = this.selProductType.productTypeId;
            this.firmProduct.tamps = this.tampProductList;

            if (this.firmProduct.compensationType == domains.CompensationType.COMMISSION_BASED) {
                this.firmProduct.advisoryFee = 0;
            } else if (this.firmProduct.compensationType == domains.CompensationType.FEE_BASED) {
                this.firmProduct.commissionRate = 0;
            }

            if (this.selDataSource) {
                this.firmProduct.dataSource = this.selDataSource.value;
                if (this.selDataSource.value == domains.DataSource.PORTFOLIO_ACCOUNTING_SYSTEM && this.selSubDataSource) {
                    this.firmProduct.subDataSource = this.selSubDataSource.value;
                }
            } else {
                this.firmProduct.dataSource = null;
                this.firmProduct.subDataSource = null;
            }

            if (!this.chechForDuplicateProducts(this.firmProduct)) {
                this.servicerService.createFirmProduct(this.firmProduct)
                    .then(response => {
                         if (this.firmProducts.map(m => m.id).indexOf(response.data.id) < 0) {
                             this.firmProducts.push(response.data);
                             this.firmProduct = {};
                             toastr.success("New product successfully registred");
                         }
                    }
                    , err => toastr.error("Product has not been created. " + err.data));
            }
            else {
                toastr.warning("Product has been already registred");
            }
        };

        chechForDuplicateProducts(firmProduct: domains.IAdvisoryFirmProduct): boolean {
            let exist: boolean = false;
            for (let i = 0; i < this.firmProducts.length; i++) {
                if (this.firmProducts[i].managerId == firmProduct.managerId && this.firmProducts[i].managerProductId == firmProduct.managerProductId && this.firmProducts[i].productTypeId == firmProduct.productTypeId)
                    exist = true;
            }
            return exist;
        };

        removeProduct(firmProduct: domains.IAdvisoryFirmProduct) {
            this.servicerService.deleteFirmProduct(firmProduct.id)
                .then(response => {
                    var ind = this.firmProducts.indexOf(firmProduct);
                    if (ind >= 0) {
                        this.firmProducts.splice(ind, 1);
                    }
                }, err => toastr.error("Product has not been removed. " + err.data));
        };

        setAdvisoryFirmProductStatus(advisoryFirmProduct: domains.IAdvisoryFirmProduct) {

            let productStatus: domains.Status;
            let msgEnd = "enabled";
            if (advisoryFirmProduct.status == domains.Status.ACTIVE) {
                productStatus = domains.Status.INACTIVE;
                msgEnd = "disabled";
            }
            else {
                productStatus = domains.Status.ACTIVE;
            }

            this.servicerService.setAdvisoryFirmProductStatus(advisoryFirmProduct, productStatus)
                .then(response => {
                    toastr.success(`Product successfully ${msgEnd}`);
                    this.loadFirmProducts(this.selManager.managerId);
                }, err => toastr.error(`Product has not been ${msgEnd}. ` + err.data));
        };

        dataSourceChanged() {
            if (this.selDataSource && this.selDataSource.value == domains.DataSource.PORTFOLIO_ACCOUNTING_SYSTEM) {
                this.generalService.getLOVs()
                    .then(data => this.subDataSources = data.filter(f => f.lovType == domains.LovType.SUB_DATA_SOURCE && f.parentId == this.selDataSource.value)
                    , err => this.generalService.showError(err));
            } else {
                this.subDataSources = [];
                this.selSubDataSource = null;
            }
        }
        // #endregion
        
        assignManager(): void {

            this.manager.id = 0;
            this.manager.managerId = this.selGlobalManager.id;
            this.manager.managerName = this.selGlobalManager.name;
            this.manager.advisoryFirmId = this.advisoryFirmId;

            this.servicerService.assignFirmManager(this.manager)
                .then((response) => {
                    angular.copy(response.data, this.manager);
                    if (this.managers.map(m => m.id).indexOf(this.manager.id) < 0) {
                        this.managers.push(response.data);
                        toastr.success("Manager has been successfully created.");
                    }
                    else {
                        toastr.success("Manager has been already assigned.");
                    }
                }).
                catch(err => {
                    toastr.error("Cannot add new manager. " + err.data);
                });
        };

        deleteFirmManager(manager: domains.IAdvisoryFirmManager): void {

            if (!window.confirm("Are you sure ?"))
                return;

            this.servicerService.deleteFirmManager(manager.id)
                .then(response => {
                    toastr.success("Link with selected Manager has been deleted.");
                    var ind = this.managers.indexOf(manager);
                    if (ind >= 0)
                        this.managers.splice(ind, 1);
                }, err => toastr.error("Cannot delete this relation manager. " + err.data));
        };

        editProductTypes(manager: domains.IAdvisoryFirmManager) {
            this.activeTab = domains.ProductCatalogTabs.Products;
            this.selManager = this.managers.filter(x => x.id == manager.id)[0];
            this.managerChanged();

        };

        
        loadGlobalManagers(): void {
            this.servicerService.getManagers()
                .then(response => this.globalManagers = response.data,
                err => this.generalService.showErrorWithMessage("Error occured during loading Global list of managers.", err) );
        };

        loadAdvisoryFee(advisoryFirmId: number): void {
            this.advisoryFirmApi.getById(advisoryFirmId)
                .success((data) => {
                    this.firmProduct.advisoryFee = data.defaultAdvisoryFee * 100;
                })
                .error((data, status) => {
                    toastr.error(`AdvisoryFee error ${status} : ${data}`);
                });
        };

        
        
        $routerOnActivate(next, previous) {
        }

        $onInit(): void {
            this.generalService.getLOVs()
                .then(data => this.dataSources = data.filter(f => f.lovType == domains.LovType.DATA_SOURCE),
                err => this.generalService.showError(err)
                );
            this.firmProduct.compensationType = domains.CompensationType.FEE_BASED;
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "advisoryFirmId" && this.advisoryFirmId > 0) {
                    this.loadGlobalManagers();
                    this.loadFirmManagers();
                    this.loadFirmTamps(this.advisoryFirmId);
                    this.loadAdvisoryFee(this.advisoryFirmId);
                }
            }
        }
    }


    class FirmManager implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<"
            };
            this.controller = FirmManagerController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/firm-manager.html";
        }
    }
    angular.module(Constants.APP).component("firmManager", new FirmManager());
}